import { render } from "./SpreadsheetSelect.vue?vue&type=template&id=5a21198c&bindings={\"userEmail\":\"setup\",\"query\":\"data\",\"files\":\"data\",\"error\":\"data\",\"attemptedId\":\"data\",\"starterTemplateSpreadsheetId\":\"options\",\"search\":\"options\"}"
import script from "./SpreadsheetSelect.vue?vue&type=script&lang=js"
export * from "./SpreadsheetSelect.vue?vue&type=script&lang=js"
script.render = render

export default script